/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/no-unescaped-entities */
import { lazy } from 'react';
import { PageLoading } from '../../../appComponents/PageLoading';
import { wrapLazyNavigatorScreen } from '../../../functions/navigation/utils/wrapNavigatorScreen';

const TermsOfServicePageContent = lazy(
  () => import('./TermsOfServiceContent.web'),
);

export const TermsOfServiceScreen = wrapLazyNavigatorScreen(
  () => {
    return <TermsOfServicePageContent />;
  },
  props => ({
    title: 'Terms of Service',
    headerShown: !(props.route.params as any)?.['popup'],
    suspenseFallback: <PageLoading style={{ backgroundColor: '#fff' }} />,
  }),
);
